import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';

const styles: ComponentStylesProps<boolean> = {
  pdfSteps: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6.4rem',
  },
  stepHeader: {
    position: 'relative',
    paddingTop: '3.2rem',
    // Layout
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '1rem 1rem 0 0',
    width: '100%',
  },
  pinnedHeader: (isSectionOpen) => ({
    top: 0,
    zIndex: 10,
    position: 'sticky',
    backgroundColor: 'white',

    boxShadow: isSectionOpen ? boxShadows.light[2] : 'none',
  }),
  attributesSectionButton: {
    textTransform: 'uppercase',
    fontWeight: 700,
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    width: '100%',
    borderRadius: 0,
  },
  stepWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    padding: { bottom: '3.2rem' },
    // Style
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
  },
  rfqStepSubtitle: {
    margin: '0 auto',
    maxWidth: '85%',
  },
  wideRfqStepSubtitle: {
    margin: '0 auto',
  },
  guidelinesWrapper: {
    position: 'absolute',
    top: '2rem',
    right: '2rem',
    cursor: 'pointer',
  },
  guidelinesMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: colors.neutral[700],
    fontSize: '1.4rem',
  },
  footer: {
    display: 'flex',
    padding: '8rem 0rem 10rem 0rem',
    justifyContent: 'center',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
